import type { ProblemFieldError } from '@/lib/problem'

/**
 * Sunucunun alan hatalarını (`errors[].field`, `core/errors.py`: gövde yolu noktalı, ör.
 * `leave.bitis`, `parts.0.amount`) form alanlarına dağıtır. `fields` sunucu yolu → form alanıdır;
 * eşlemede olmayan yol `known` içindeyse olduğu gibi kullanılır (form adı sunucu adıyla aynıysa).
 * Hiçbir alana düşmeyenler `rest`'e kalır; ekran onları genel hata olarak gösterir.
 */
export function splitServerErrors<TField extends string>(
  errors: readonly ProblemFieldError[],
  fields: Partial<Record<string, TField>>,
  known: (path: string) => path is TField,
): { byField: Array<[TField, string]>; rest: string[] } {
  const byField: Array<[TField, string]> = []
  const rest: string[] = []
  for (const error of errors) {
    const target = fields[error.field] ?? (known(error.field) ? error.field : undefined)
    if (target === undefined) rest.push(error.message)
    // Aynı alana birden çok hata gelirse ilki gösterilir.
    else if (!byField.some(([field]) => field === target)) byField.push([target, error.message])
  }
  return { byField, rest }
}
